const sanityClient = require("@sanity/client");
const { api } = require("../../../studio/sanity.json");

let useCdn = true;
if (process.env.NODE_ENV === "2025") {
  useCdn = false;
}
api.dataset = process.env.VUE_APP_SANITY_DATASET;
const client = sanityClient({ ...api, useCdn: useCdn });

const sanityAPI = sanityClient({ ...api, useCdn: false });

module.exports.sanityClient = client;
module.exports.sanityRWClient = client;
module.exports.sanityAPIClient = sanityAPI;
console.log("Using sanity dataset");
console.log({ api });
